import {
  Fab,
  List,
  ListItem,
  ListItemText,
  Theme,
  Zoom,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { useTheme } from "@material-ui/styles";
import * as React from "react";
import { Link, RouteComponentProps } from "react-router-dom";
import { isMobile, MarrowRoutes } from "../../AppLayout";
import { useStyles } from "./style";

interface Props extends RouteComponentProps {
  isHomepage?: boolean;
}

export const Navigation: React.FC<Props> = ({
  isHomepage,
  history: { location },
}) => {
  const theme = useTheme<Theme>();
  const classes = useStyles(theme);
  const [menuOpen, setMenuOpen] = React.useState(false);

  const visibleRoutes = MarrowRoutes.filter((r) => !r.hidden);

  return (
    <div
      className={`${classes.topbar} ${isHomepage ? "home" : ""}`}
      style={isMobile ? { display: "flex", justifyContent: "center", backgroundColor: 'white' } : {}}
    >
      <div style={isMobile ? {display: 'flex', zIndex:3, ...(isHomepage ? { position: 'fixed', marginTop: 50 } : {})}:undefined}>
        <Link to={"/"}>
          {isMobile && !isHomepage ? (
             <img
              src="/img/logo-responsive.png"
              alt="Marrow Logo"
              style={{ height: 130 }}/>
          ) : (
            <img src="/img/logo.png" alt="Marrow Logo" style={{ height: isHomepage ? 75 : 50 }} />
        )}
      </Link>
      </div>


      {isMobile ? (
        !isHomepage && (
          <React.Fragment>
            <Fab
              color="primary"
              aria-label="Menu"
              className={classes.mobileMenu}
              onClick={(e) => setMenuOpen((prevMenuOpen) => !prevMenuOpen)}
            >
              <MenuIcon />
            </Fab>

            <Zoom in={menuOpen} style={{ transformOrigin: "top right" }}>
              <List
                className={`${classes.mobileMenu} ${classes.mobileMenuExpanded}`}
                component="nav"
                aria-label="Expanded Menu"
              >
                {visibleRoutes.map(({ url, path, label, external }, i) => (
                  !external?
                  <ListItem
                    className={classes.mobileMenuItem}
                    key={i}
                    button
                    component="a"
                    href={url??path}
                  >
                    <ListItemText primary={label} />
                  </ListItem>:(
                  <ListItem
                    className={classes.mobileMenuItem}
                    key={i}
                    button
                    component="a"
                    href={url??path}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                  <ListItemText primary={label} />
                  <OpenInNewIcon
                    style={{
                      fontSize: 16,
                      marginLeft: 4,
                      verticalAlign: "middle",
                    }}
                  />
                </ListItem>
)
                ))}
              </List>
            </Zoom>
          </React.Fragment>
        )
      ) : (
        <ul className={classes.navigation}>
          {visibleRoutes.map(({ url, path, label, external }, i) =>
            external ? (
              <li key={i}>
                <a
                  href={path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${classes.menuItem} ${
                    isHomepage ? "home" : "notHome"
                  }`}
                  style={{ display: "inline-flex", alignItems: "center" }}
                >
                  {label}
                  <OpenInNewIcon
                    style={{
                      fontSize: 16,
                      marginLeft: 4,
                      verticalAlign: "middle",
                    }}
                  />
                </a>
              </li>
            ) : (
              <li key={i}>
                <Link
                  to={url ?? path}
                  className={`${classes.menuItem} ${
                    isHomepage ? "home" : "notHome"
                  }`}
                  style={{
                    color:
                      location.pathname === (url ?? path)
                        ? theme.palette.primary.main
                        : "",
                  }}
                >
                  {label}
                </Link>
              </li>
            )
          )}
        </ul>
      )}
    </div>
  );
};
